import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { EagerSelectEffects } from '../../select/eager-select/eager-select-effects';
import { userOptionActions } from './user-option.actions';
import { userOptionSelectors } from './user-option.reducer';

@Injectable({ providedIn: 'root' })
export class UserOptionEffects {
   defaultFields: string[] = ['name', 'userId'];

   defaultOrderingOptions: string[] = ['name:asc'];

   staticFilters: string[] = [];

   load = this.eagerSelectEffects.createEagerSelectorLoadEffect(
      userOptionSelectors.selectState,
      'users',
      this.defaultFields,
      this.defaultOrderingOptions,
      userOptionActions,
      this.staticFilters
   );

   constructor(private eagerSelectEffects: EagerSelectEffects<AppState>, private store: Store) {}
}
